import { registerPharmacyHandlingMedicines } from '@/utils/graphqlApis';
import { useMutation, useQueryClient } from 'react-query';
import useAuth from '../auth/useAuth';
import { RegisterPharmacyHandlingMedicinesVariables } from '@/api/bff_types';
import { MEDICINES_QUERY_KEY } from './queryKeys';

const useRegisterPharmacyHandlingMedicines = () => {
  const { token } = useAuth();
  const queryClient = useQueryClient();

  const { mutate: registerPharmacyHandlingMedicinesMutate } = useMutation(
    (variables: RegisterPharmacyHandlingMedicinesVariables) =>
      registerPharmacyHandlingMedicines(variables, token),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(MEDICINES_QUERY_KEY.ALL);
      }
    }
  );
  return {
    registerPharmacyHandlingMedicinesMutate
  };
};

export default useRegisterPharmacyHandlingMedicines;
